const product = [
  {
    path: '/products',
    name: 'products.index',
    component: () => import('@/views/products/ProductList'),
    meta: {
      need_capability: 'products',
      pageTitle: 'Produtos',
      roles: [1, 2, 5,6],
      breadcrumb: [
        {
          text: 'Lista',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/new',
    name: 'products.new',
    component: () => import('@/views/products/product-form/ProductForm'),
    meta: {
      need_capability: 'products',
      pageTitle: 'Produtos',
      roles: [1, 2, 5,6],
      breadcrumb: [
        {
          text: 'Lista',
          active: false,
          to: '/products',
        },
        {
          text: 'Novo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/products/:uuid/edit',
    name: 'products.edit',
    component: () => import('@/views/products/product-form/ProductForm'),
    meta: {
      need_capability: 'products',
      roles: [1, 2, 5,6],

      pageTitle: 'Produtos',
      breadcrumb: [
        {
          text: 'Lista',
          active: false,
          to: {type:'history', default:'/products' },
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/catalog/products',
    name: 'products.catalog.index',
    component: () => import('@/views/products/catalog/ProductCatalogList'),
    meta: {
      need_capability: 'catalog',
      roles: [1, 2, 5,6],
      env:['production'],
      pageTitle: 'Catálogo',
      breadcrumb: [
        {
          text: 'Lista',
          active: true,
        },
      ],
    },
  },
  {
    path: '/catalog/improve-catalog',
    name: 'products.improve-catalog.index',
    component: () => import('@/views/products/catalog/improve-catalog/ImproveList'),
    meta: {
      need_capability: 'product_improve',
      roles: [1, 2, 5,6],
      env:['production'],
      pageTitle: 'Melhorias de Produtos por Catálogo',
    },
  },
  {
    path: '/catalogs/list',
    name: 'catalog.index',
    component: () => import('@/views/products/catalog/Cataloglist'),
    meta: {
      need_capability: 'catalog',
      roles: [5],
      env:['production'],
      pageTitle: 'Catálogo de Produtos',
      breadcrumb: [
        {
          text: 'Lista',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price-table',
    name: 'price-table.list',
    component: () => import('@/views/tableprice/TablePriceList.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Tabelas de Preços',
      breadcrumb: [
        {
          text: 'Lista',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price-table/import',
    name: 'price-table.import',
    component: () => import('@/views/tableprice/TablePriceImport.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Importar planilha de precificação',
      breadcrumb: [
        {
          text: 'Tabelas de Preços',
          active: false,
          to: '/price-table',
        },
        {
          text: 'Importar planilha',
          active: true,
        },
      ],
    },
  },
  {
    path: '/precificacao/custos-canais',
    name: 'precificacao.custos-canais',
    component: () => import('@/views/price/SalesChannelCosts.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Custos dos Canais',
      breadcrumb: [
        {
          text: 'Precificação',
          active: false,
        },
        {
          text: 'Custos dos canais',
          active: true,
        },
      ],
    },
  },
  {
    path: '/precificacao/custos-operacionais',
    name: 'precificacao.custos-operacionais',
    component: () => import('@/views/price/CustosOperacionais.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Custos Operacionais',
      breadcrumb: [
        {
          text: 'Precificação',
          active: false,
        },
        {
          text: 'Custos operacionais',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacoes/custos-produtos',
    name: 'importacoes.custos-produtos',
    component: () => import('@/views/importacoes/ImportacoesCustosProdutos.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Importações de Custos e Preços',
      breadcrumb: [
        {
          text: 'Produtos',
          active: false,
          to: '/products',
        },
        {
          text: 'Importações de custos e preços',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacoes/custos-produtos/nova',
    name: 'importacoes.custos-produtos.nova',
    component: () => import('@/views/importacoes/ImportacaoPlanilhaCustos.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Importação de Planilha de Custos e Preços',
      breadcrumb: [
        {
          text: 'Produtos',
          active: false,
          to: '/products',
        },
        {
          text: 'Importações de custos e preços',
          active: false,
          to: '/importacoes/custos-produtos',
        },
        {
          text: 'Nova importação',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacoes/custos-produtos/nova/configurar-campos',
    name: 'importacoes.custos-produtos.configurar-campos',
    component: () => import('@/views/importacoes/ConfiguracaoCamposImportacao.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Configurar Campos da Importação',
      breadcrumb: [
        {
          text: 'Importações de custos e preços',
          active: false,
          to: '/importacoes/custos-produtos',
        },
        {
          text: 'Nova importação',
          active: false,
          to: '/importacoes/custos-produtos/nova',
        },
        {
          text: 'Configurar campos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacoes/custos-produtos/:id(\\d+)',
    name: 'importacoes.custos-produtos.detalhe',
    component: () => import('@/views/importacoes/ImportacaoCustosProdutosDetalhe.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Detalhe da Importação',
      breadcrumb: [
        {
          text: 'Importações de custos e preços',
          active: false,
          to: '/importacoes/custos-produtos',
        },
        {
          text: 'Detalhe',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacoes/custos-produtos/:id(\\d+)/precificacao',
    name: 'importacoes.custos-produtos.precificacao',
    component: () => import('@/views/importacoes/PrecificacaoImportacao.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 2, 5,6],
      pageTitle: 'Trabalhar Preços',
      breadcrumb: [
        {
          text: 'Importações de custos e preços',
          active: false,
          to: '/importacoes/custos-produtos',
        },
        {
          text: 'Trabalhar preços',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price-table/new',
    name: 'price-table.new',
    component: () => import('@/views/tableprice/TablePriceForm.vue'),
    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 5,6],
      pageTitle: 'Tabelas de Preços',
      breadcrumb: [
        {
          text: 'Lista',
          active: false,
          to: '/price-table',
        }, {
          text: 'novo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price-table/:uuid/edit',
    name: 'price-table.edit',
    component: () => import('@/views/tableprice/TablePriceForm.vue'),

    meta: {
      need_capability: 'pricing',
      env:['production'],
      roles: [1, 5,6],
      pageTitle: 'Tabelas de Preços',
      breadcrumb: [
        {
          text: 'Lista',
          active: false,
          to: '/price-table',
        }, {
          text: 'Editar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/categories/map/erp',
    name: 'products.categories.map',
    component: () => import('@/views/Categories/MapCategories.vue'),
    meta: {
      need_capability: 'product_categorization',
      env:['production'],
      roles: [1, 5, 2,6],
      pageTitle: 'Mapear Categorias',
    },
  },
  {
    path: '/products/default-size-weight',
    name: 'products.default-size-weight',
    component: () => import('@/views/products/ProductDefaultSpecs.vue'),
    meta: {
      need_capability: 'product_specs',
      env:['production'],
      roles: [1, 2, 5, 6],
      pageTitle: 'Especificações Padrão de Produtos',
    }
  },
  {
    path: '/products/promotions',
    name: 'promotions',
    component: () => import('@/views/products/Promotions.vue'),
    meta: {
      need_capability: 'product_promotions',
      env: ['production'],
      roles: [1, 2, 5, 6],
      pageTitle: 'Promoções'
    }
  },
  {
    path: '/products/promotions/new',
    name: 'promotions.new',
    component: () => import('@/views/products/PromotionsForm.vue'),
    meta: {
      need_capability: 'product_promotions',
      env: ['production'],
      roles: [1, 5, 6],
      pageTitle: 'Nova Promoção'
    }
  },
  {
    path: '/products/promotions/:promo_id/edit',
    name: 'promotions.edit',
    component: () => import('@/views/products/PromotionsForm.vue'),
    meta: {
      need_capability: 'product_promotions',
      env: ['production'],
      roles: [1, 5, 6],
      pageTitle: 'Editar Promoção'
    }
  }
]

export default product
